import * as ExcelJS from 'exceljs';
import { parseFromFile, workbookToBuffer } from '@/lib/excel';
import * as path from 'path';
import { processGradeFactorReport, GradeFactorReport } from './utils/gradeFactorProcessor';

async function parseGradeFactorFiles(files: File[]) {
    try {
        return Promise.all(files.map(gf_file => parseFromFile(gf_file)));
    } catch (error) {
        console.error('Error parsing grade factor reports:', error);
        throw error;
    }
}

export async function runReport({
    month_a, month_b, gf_file, CADtoUSD_rate
}: {
    month_a: {
        unsettled_ap_us?: File;
        unsettled_ap_can?: File;
        unsettled_ar_can?: File;
        unsettled_ar_us?: File;
        name: string;
    };
    month_b: {
        unsettled_ap_us?: File;
        unsettled_ap_can?: File;
        unsettled_ar_can?: File;
        unsettled_ar_us?: File;
        name: string;
    };
    gf_file: File | File[],
    CADtoUSD_rate?: number,
}) {
    const gf_files = Array.isArray(gf_file) ? gf_file : [gf_file];
    const gf_reports = await parseGradeFactorFiles(gf_files);
    if (gf_reports.some(report => report.data == null)) {
        const error = 'Error parsing grade factor reports: report.data from one or more gf_reports was null';
        console.error(error, gf_reports);
        throw error;
    }
    const gfCharges = gf_reports.map(report => report.data!.excelJsWorkbook);

    const reports: GradeFactorReport = {
      // Current Month (June)
      currentMonth: {
        apUS: month_a.unsettled_ap_us ? (await parseFromFile(month_a.unsettled_ap_us) as any).data.excelJsWorkbook : undefined,
        apCAD: month_a.unsettled_ap_can ? (await parseFromFile(month_a.unsettled_ap_can) as any).data.excelJsWorkbook : undefined,
        arCAD: month_a.unsettled_ar_can ? (await parseFromFile(month_a.unsettled_ar_can) as any).data.excelJsWorkbook : undefined,
        arUS: month_a.unsettled_ar_us ? (await parseFromFile(month_a.unsettled_ar_us) as any).data.excelJsWorkbook : undefined
      },
      // Previous Month (May)
      previousMonth: {
        apUS: month_b.unsettled_ap_us ? (await parseFromFile(month_b.unsettled_ap_us) as any).data.excelJsWorkbook : undefined,
        apCAD: month_b.unsettled_ap_can ? (await parseFromFile(month_b.unsettled_ap_can) as any).data.excelJsWorkbook : undefined,
        arCAD: month_b.unsettled_ar_can ? (await parseFromFile(month_b.unsettled_ar_can) as any).data.excelJsWorkbook : undefined,
        arUS: month_b.unsettled_ar_us ? (await parseFromFile(month_b.unsettled_ar_us) as any).data.excelJsWorkbook : undefined
      },
      // GF Charges
      gfCharges,
    };

    const reportWorkbook = await processGradeFactorReport(reports, month_a.name, month_b.name, CADtoUSD_rate);

    // Save the report
    const currentDate = new Date().toISOString().split('T')[0];

    return {
        buffer: await workbookToBuffer(reportWorkbook)
    };
}
